

























import { ItemValue, Base } from "survey-core";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { BaseVue } from "./base";

@Component
export class CheckboxItem extends BaseVue {
  @Prop() question: any;
  @Prop() item: ItemValue;
  @Prop() hideLabel: boolean;
  protected getModel(): Base {
    return this.item;
  }
}
Vue.component("survey-checkbox-item", CheckboxItem);
export default CheckboxItem;
